import React, { useEffect, useState } from "react";
import QuestionTabs from "./QuestionTabs";
import PaginationNew from "../common/Pagination";
import api from "../../seller-apis/api";
import { fetchansQA, fetchunansQA } from "../../seller-apis/apidataField";
import SubmitAnswerModal from "../common/SubmitAnswerModal";
import { Actions } from "../../Actions/Actions";
import { useDispatch } from "react-redux";
import { formatedDate } from "../../utilities/ConvertDateFormat";
import MainLoader from "../common/Loader/PageLoader";
var filterData = {};

function AnsweredQuestions(props) {
  const dispatch = useDispatch();
  const [answQ, setanswQ] = useState([]);
  const [totalrecords, setTotalRecords] = useState();
  const [selectedPage, setSelectedPage] = useState(1);
  const [selectedData, setSelectedData] = useState(null);
  const [vendorId, setVendorId] = useState(null);
  const [ansIndex, setAnsIndex] = useState(null);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(true);
  const handleClose = () => {
    setShow(false);
  };
  useEffect(() => {
    filterData = {
      pageNo: "1",
      type:"ANSWERED"
    };
    getQA(filterData);
    setVendorId(localStorage.getItem('vendorId'));
  }, []);
  function getQA(data = filterData) {
    setLoading(true);
    api.QandA.fetchQA(fetchunansQA(data)).then((res) => {
      // Actions.upadteQuesCount(dispatch,res.totalRecords);
      setanswQ([...res.data]);
      setTotalRecords(res.totalRecords);
      setLoading(false);
    });
  }
  function paginate(data) {
    filterData = {
      pageNo: data.number,
      type:"ANSWERED"
    };
    getQA(filterData);
    setSelectedPage(data.number);
  }

  if (loading) {
    return (
      <div className="question_loading_box">
        <div>
          <MainLoader />
        </div>
      </div>
    )
  }
  else {
    return (
      <>
        <div className="question-container table-responsive">
          <table className="w-100 new-table-design pt-2">
            <tr>
              <th style={{ width: "15%" }}>Image</th>
              <th style={{ width: "25%" }}>Product</th>
              <th style={{ width: "25%" }}>Question</th>
              <th style={{ width: "35%" }}>Answer</th>
            </tr>
            {answQ.length > 0 &&
              answQ.map((item, index) => {
                // let baseImg = "";
                // item.productId.images.map((item) => {
                //   if (item.baseImage === true) {
                //     if (item.image.startsWith("products")) {
                //       baseImg = item.image;
                //     } else {
                //       let img = item.image.substr("41");
                //       baseImg = img;
                //     }
                //   }
                // });

                let answerIndex;
                item.answers.forEach((ans, index) => {
                  if (ans.sellerId == vendorId) {
                    answerIndex = index
                  }
                })
                let answer = item.answers[answerIndex];
                console.log(answer, vendorId,);
                return (
                  <tr>
                    <td>
                      <div className="border-x">
                        <img
                          src={"https://s3.toolsvilla.com/" + item.productId.images[0].image}
                          className="col3"
                        ></img>
                      </div>
                    </td>
                    <td>
                      <div className=" text-left border-x px-2">
                        <div className="product-name text-left w-100 mt-1">
                          {item.productId.productName}
                        </div>
                        <div className="question-sku-but">
                          <div className="sku w-100">
                            SKU : {item.productId.SKU}
                          </div>
                          <a
                            href={`/productDetail/${item.productId._id}/approv`}
                            target="_blank"
                            // onClick={() => detailnew(props.url)}
                            className="detail-but"
                          >
                            <button className="px-1 order_table_btn_details">
                              Details
                            </button>
                          </a>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className=" text-left border-x question">
                        {item.question}
                      </div>
                    </td>
                    <td>
                      <div className="border-x p-3">
                        <div className="product-name mb-2 text-left w-100 fw-700 text-break">
                          {answer?.answer}
                        </div>

                        <div className="pendin-approval">
                          <div>
                            {!answer?.verified ? (
                              <div className="answer-status mb-2">
                                <img
                                  src="/exclamation.webp"
                                  alt="icon"
                                  style={{ width: 12 }}
                                />
                                <div>Pending for approval</div>
                              </div>
                            ) : (
                              <div className="answer-status main-color mb-2">
                                <img
                                  src="/shield.png"
                                  alt="icon"
                                  style={{ width: 12 }}
                                />
                                <div>Approved</div>
                              </div>
                            )}
                            <div className="date text-left">
                              Answered On -{" "}
                              {answer?.updatedAt
                                ? formatedDate(answer?.updatedAt)
                                : "N/A"}
                            </div>
                          </div>
                          <div>
                            <button className="edit-button icon-but ques-edit-padding" onClick={() => {
                              setSelectedData(item);
                              setShow(true);
                              setAnsIndex(answerIndex);
                            }}>
                              {" "}
                              <img src="/edit-underline.webp" /> Edit Answer
                            </button>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })}
          </table>
          <PaginationNew
            number={totalrecords}
            paginate={paginate}
            activ={selectedPage}
            comp={"pending"}
          />
          {show ? (
            <SubmitAnswerModal
              data={selectedData}
              edit={true}
              answerIndex={ansIndex}
              show={show}
              handleClose={handleClose}
              refreshData={getQA}
            />
          ) : (
            ""
          )}
        </div>
      </>
    );
  }
}

export default AnsweredQuestions;
